define( [
	"./document"
], function( document ) {
	return document.documentElement;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/documentElement.js
 ** module id = 872
 ** module chunks = 2
 **/